const _require = require('lodash'),
  isPlainObject = _require.isPlainObject;
const _require2 = require('@truqc/content-path'),
  getValue = _require2.getValue;
const _require3 = require('../lib/evaluateSource'),
  evaluateSource = _require3.evaluateSource;

/**
  * @function evalute - evaluate getObjectValueBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (!isPlainObject(object)) {
    return undefined;
  }
  const path = await evaluateSource(source.path, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof path !== 'string') {
    return undefined;
  }
  const value = getValue(path, object);
  const evaluatedValue = await evaluateSource(value, content, parentContentPath, transientContext, nativeFunctions);
  return evaluatedValue;
};
module.exports = {
  evaluate
};